function slideUp(el, duration) {
  el.style.overflow = "hidden";
  el.style.height = el.scrollHeight + "px";
  el.style.transition = "height " + duration + "ms ease";
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      el.style.height = "0px";
    });
  });
  window.setTimeout(function () {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition");
  }, duration);
}

function slideDown(el, duration) {
  el.style.removeProperty("display");
  var display = window.getComputedStyle(el).display;
  if (display === "none") display = "block";
  el.style.display = display;
  el.style.overflow = "hidden";
  el.style.height = "0px";
  el.style.transition = "none";
  var height = el.scrollHeight;
  el.style.transition = "height " + duration + "ms ease";
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      el.style.height = height + "px";
    });
  });
  window.setTimeout(function () {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition");
  }, duration);
}

function slideToggle(el, duration) {
  if (window.getComputedStyle(el).display === "none") {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.__fabricAndFinishesInit) return;
  window.__fabricAndFinishesInit = true;

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".third_cross");
    if (!trigger) return;
    e.preventDefault();
    document.querySelectorAll(".Product-Mail-Button").forEach(function (btn) {
      btn.classList.remove("active");
    });
    trigger.classList.add("active");
    document.querySelectorAll(".modal3").forEach(function (modal) {
      modal.classList.toggle("is-visible");
    });
  });

  var get_url = window.location.href;
  if (get_url.includes("#fabric-finishes")) {
    document.querySelectorAll(".Product-Mail-Button").forEach(function (btn) {
      btn.classList.remove("active");
    });
    document.querySelectorAll(".modal3").forEach(function (modal) {
      modal.classList.toggle("is-visible");
    });
  }

  document.addEventListener("click", function (e) {
    var link = e.target.closest("a[href*='#fabric-finishes']");
    if (!link) return;
    e.preventDefault();
    document.querySelectorAll(".Product-Mail-Button").forEach(function (btn) {
      btn.classList.remove("active");
    });
    document.querySelectorAll(".modal3").forEach(function (modal) {
      modal.classList.toggle("is-visible");
    });
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest(".continue_browser")) {
      parent.history.back();
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest(".close_button_custom_popup")) {
      var popupDiv = document.querySelector(".popup_div.product_custom_view");
      var modal3 = document.querySelector(".modal3");
      popupDiv.style.display = "none";
      modal3.classList.remove("model_animation-start");
    }
  });

  document.addEventListener("click", function (e) {
    var el = e.target.closest(".product_deatilsss");
    if (!el) return;
    console.log("Product detail clicked");

    var popupDiv = document.querySelector(".popup_div.product_custom_view");
    var modal3 = document.querySelector(".modal3");

    popupDiv.style.display = "block";
    popupDiv.classList.remove("animation-start");
    modal3.classList.remove("model_animation-start");

    var input = el.closest(".Swatches_inner").querySelector("input");
    var full_url = "/products/" + input.value + "?view=custom-view";
    console.log(full_url);

    fetch(full_url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        console.log("Fetched HTML:", html);
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var content = doc.querySelector(".product_wrapper");
        console.log("Extracted content:", content);

        popupDiv.classList.add("animation-start");
        modal3.classList.add("model_animation-start");
        popupDiv.innerHTML = content ? content.innerHTML : "";
      });
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".add_to_cart");
    if (!btn) return;

    var ID = btn.getAttribute("data-value");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: 1, id: ID }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        var msg = document.querySelector(".sucess_message");
        msg.style.display = "block";
        msg.style.opacity = "1";
        setTimeout(function () {
          msg.style.opacity = "0";
          setTimeout(function () {
            msg.style.display = "none";
          }, 600);
        }, 2000);

        setTimeout(function () {
          var popupDiv = document.querySelector(".popup_div.product_custom_view");
          var modal3 = document.querySelector(".modal3");
          if (popupDiv) popupDiv.classList.remove("animation-start");
          if (modal3) modal3.classList.remove("model_animation-start");
        }, 2000);

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: { variant: product.id },
          })
        );
      });
  });

  document.querySelectorAll(".acc__title").forEach(function (title) {
    title.addEventListener("click", function (j) {
      var card = title.closest(".acc__card");
      var dropDown = card ? card.querySelector(".acc__panel") : null;

      if (title.classList.contains("active")) {
        title.classList.remove("active");
      } else {
        var acc = title.closest(".acc");
        if (acc) {
          acc
            .querySelectorAll(".acc__title.active")
            .forEach(function (activeTitle) {
              activeTitle.classList.remove("active");
            });
          acc.querySelectorAll(".acc__panel").forEach(function (panel) {
            if (panel !== dropDown) {
              slideUp(panel, 600);
            }
          });
        }
        title.classList.add("active");
      }

      if (dropDown) {
        slideToggle(dropDown, 600);
      }

      j.preventDefault();
    });
  });
});
